module.exports = __webpack_public_path__ + "static/media/display-suite-19.49ffe78e.jpg";